
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ConnectionWarning from '@/components/ConnectionWarning';
import CongratulatoryMessage from '@/components/payment/CongratulatoryMessage';
import CounselorListing from '@/components/career-counselors/CounselorListing';
import { useCareerCounselors, CAREER_COUNSELOR_ID } from '@/hooks/useCareerCounselors';
import { toast } from 'sonner';

const CareerCounselors = () => {
  // Destructure 'counselors' directly from the hook
  const { counselors, loading } = useCareerCounselors();
  
  useEffect(() => {
    // Check if the Career Counselor ID is loaded
    if (!CAREER_COUNSELOR_ID) {
      console.warn('Career Counselor ID not loaded yet. Some features may not work correctly.');
    } else {
      console.log('Career Counselor ID loaded:', CAREER_COUNSELOR_ID);
    }
  }, []);

  // Load the testimonial widget script
  useEffect(() => {
    const loadTestimonialWidget = () => {
      const script = document.createElement('script');
      script.src = 'https://reviewmanagementtool.com/widget.js';
      script.onload = function() {
        if (window.TestimonialWidget) {
          window.TestimonialWidget.load('6469b98b-995f-46f1-bea5-d59a482dbd67');
        }
      };
      document.head.appendChild(script);
    };

    loadTestimonialWidget();

    // Cleanup function to remove script when component unmounts
    return () => {
      const existingScript = document.querySelector('script[src="https://reviewmanagementtool.com/widget.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);
  
  console.log('Career Counselors page loaded with', counselors.length, 'counselors');

  return (
    <>
      <Helmet>
        <title>Career Counselors | Career Guide Kerala</title>
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Navbar />
        
        <main className="flex-1">
          <div className="container mx-auto px-4 py-8">
            <ConnectionWarning />
            {counselors.length > 0 && <CongratulatoryMessage />}
            
            <CounselorListing 
              counselors={counselors}
              loading={loading}
            />
          </div>
        </main>
        
        {/* Testimonial Widget */}
        <div className="container mx-auto px-4 py-8">
          <div id="testimonial-widget-6469b98b-995f-46f1-bea5-d59a482dbd67"></div>
        </div>
        
        <Footer />
      </div>
    </>
  );
};

export default CareerCounselors;
